import React, { useEffect, useState } from 'react'
import { Widget } from '@typeform/embed-react'
import { useNavigate } from 'react-router-dom'
import { useAppSelector } from '../../store/hooks'
import { selectAuthenticatedUser } from '../../store/auth/authSlice'
import { useIntercom } from 'react-use-intercom'
import { useLazyGetUserHashQuery } from '../../store/user/user'

const ONBOARDING_CODE_QUERY_PARAM = 'onboarding_code'
const EMAIL_QUERY_PARAM = 'email'
const USER_ID_QUERY_PARAM = 'user_id'
const BD_SOURCE_QUERY_PARAM = 'bd_source'
const ONBOARDING_FORM_ID = process.env.REACT_APP_TYPEFORM_FORM_ID!
const DASHBOARD_URL = process.env.REACT_APP_DASHBOARD_URL!

export const OnboardingView: React.FC = () => {
  const navigate = useNavigate()
  const authenticatedUser = useAppSelector(selectAuthenticatedUser)
  const [booted, setBooted] = useState(false)
  const { boot, hide } = useIntercom()
  const [triggerGetUserHashQuery] = useLazyGetUserHashQuery()

  useEffect(() => {
    const getUserHash = async (accountId: string) => {
      const hash = await triggerGetUserHashQuery({ accountId: accountId })
      return hash
    }

    if (!booted && authenticatedUser) {
      getUserHash(authenticatedUser.accountId).then(({ data: userHash }) => {
        boot({
          email: authenticatedUser.email,
          createdAt: authenticatedUser.createdAt,
          userId: authenticatedUser.id,
          userHash,
        })
        hide()
        setBooted(true)
      })
    }
  }, [booted, boot])

  const onSubmit = () => {
    if (authenticatedUser) {
      window.location.href = `${DASHBOARD_URL}/getting-started/start`
    } else {
      navigate('/wait-list')
    }
  }
  return (
    <Widget
      id={ONBOARDING_FORM_ID}
      fullScreen
      onSubmit={onSubmit}
      transitiveSearchParams={[ONBOARDING_CODE_QUERY_PARAM, EMAIL_QUERY_PARAM, USER_ID_QUERY_PARAM, BD_SOURCE_QUERY_PARAM]}
    />
  )
}
